import React, { FunctionComponent, useState } from "react";
import { Form, Select } from "antd";
import FormLabel from "./FormLabel";
import styles from "../BiformLayout.module.scss";
import { QuestionComponentProps } from "../helper";

// DROPDOWN — pick exactly one option from a dropdown.
// A question marked `metadata.isJobStage` (the job-survey stage) renders as an OPEN combobox: the
// learner can pick a preset stage OR type their own if theirs isn't listed. Every other dropdown
// stays a fixed select.
const SingleSelect: FunctionComponent<QuestionComponentProps> = ({ question, disabled = false }) => {
  const isJobStage = Boolean((question as { metadata?: { isJobStage?: boolean } })?.metadata?.isJobStage);
  const options = question.options || [];
  const [term, setTerm] = useState("");

  const q = term.trim().toLowerCase();
  const visibleOptions = isJobStage && q ? options.filter(o => (o.label || "").toLowerCase().includes(q)) : options;
  const showCustom = isJobStage && Boolean(q) && !options.some(o => (o.label || "").toLowerCase() === q);

  return (
    <Form.Item
      name={question.id}
      label={<FormLabel label={question.label} required={question.isRequired} description={question.description} />}
      rules={[{ required: question.isRequired, message: "Please select an option!" }]}
      className={styles.disableSingleSelectInput}
    >
      <Select
        disabled={disabled}
        placeholder={question.placeholder || (isJobStage ? "Select or type the stage" : "Select")}
        allowClear
        showSearch={isJobStage || undefined}
        filterOption={isJobStage ? false : undefined}
        onSearch={isJobStage ? setTerm : undefined}
        onChange={isJobStage ? () => setTerm("") : undefined}
        notFoundContent={isJobStage ? "Type to add a stage" : undefined}
      >
        {visibleOptions.map(option => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
        {showCustom ? (
          <Select.Option key={term} value={term.trim()}>
            {term.trim()}
          </Select.Option>
        ) : null}
      </Select>
    </Form.Item>
  );
};

export default SingleSelect;
